import { z } from 'zod';
import { dentalGroup, groupStatus } from './group.js';
import { paginatedResult, paginationQuery } from './common.js';
export const managedPractice = dentalGroup.extend({ canEdit: z.boolean() });
export const managedPracticePage = paginatedResult(managedPractice).extend({
  canCreate: z.boolean(),
});
export type ManagedPractice = z.infer<typeof managedPractice>;
export type ManagedPracticePage = z.infer<typeof managedPracticePage>;
export const practiceListQuery = paginationQuery.extend({
  search: z.string().trim().max(100).optional(),
  status: groupStatus.optional(),
});
export const practiceCreateRequest = z.object({
  name: z.string().trim().min(1).max(150),
  clientRequestId: z.string().uuid().optional(),
});
export const practiceUpdateRequest = z
  .object({
    name: z.string().trim().min(1).max(150).optional(),
    status: groupStatus.optional(),
    settings: z.record(z.string(), z.unknown()).nullish(),
    expectedName: z.string().optional(),
    expectedStatus: groupStatus.optional(),
  })
  .refine(
    (value) =>
      value.name !== undefined || value.status !== undefined || value.settings !== undefined,
    'Choose a change to save.'
  );

export type PracticeListQuery = z.infer<typeof practiceListQuery>;
export type PracticeUpdateRequest = z.infer<typeof practiceUpdateRequest>;
